import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
const AllQuote = props => {
	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					{/* Render Breadcrumb */}
					<Breadcrumbs title={props.t('Quotations')} breadcrumbItem={props.t('Quotations')} />

					<Row>
						<Col className="text-center mt-5" xl="12">
							No Quote Found
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

AllQuote.propTypes = {
	t: PropTypes.any
};

export default withTranslation()(AllQuote);
